import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { TenantScheduleDetailsComponent } from './tenant-schedule-details.component';
import { ExternalTenantGuard } from 'src/app/services/util/external-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: TenantScheduleDetailsComponent,
    title: 'Tenant Schedule Details',
    canActivate: [ExternalTenantGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantScheduleDetailsRoutingModule {
}